<template>
  <section class="indicadores-section">
    <b-container>
      <b-row>
        <b-col>
          <h2 class="heading">Indicadores</h2>
          <h3 class="subheading">Vacinação HPV</h3>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="container-dashboard">
      <b-row>
        <b-col>
          <dashboard-vacinacao-hpv />
          <p class="mb-4 mb-lg-5 indicadores-section__note-text">
            *Os dados referentes ao ano de 2024 são parciais.
          </p>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row>
        <b-col>
          <h3 class="subheading">Exame Citopatológico</h3>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="container-dashboard">
      <b-row>
        <b-col>
          <dashboard-cobertura-coleta class="mb-4 mb-lg-5" />
          <dashboard-efetividade-coleta />
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import DashboardVacinacaoHpv from '@/components/CancerColoUtero/DashboardVacinacaoHpv/DashboardVacinacaoHpv.vue';
import DashboardCoberturaColeta from '@/components/CancerColoUtero/DashboardCoberturaColeta/DashboardCoberturaColeta.vue';
import DashboardEfetividadeColeta from '@/components/CancerColoUtero/DashboardEfetividadeColeta/DashboardEfetividadeColeta.vue';

export default {
  name: 'indicadores-section-cancer-colo-utero',
  components: {
    'dashboard-vacinacao-hpv': DashboardVacinacaoHpv,
    'dashboard-cobertura-coleta': DashboardCoberturaColeta,
    'dashboard-efetividade-coleta': DashboardEfetividadeColeta,
  },
};
</script>

<style lang="scss" scoped>
@include media-breakpoint-only(xs) {
  .container-dashboard {
    padding: 0;
     & > .row {
      margin: 0;
      & > .col { padding: 0; }
    }
  }
}

.heading {
  color: $primary;
  font-weight: 600;
  font-size: 1.375rem;
  text-align: center;
  line-height: 1.36;
  margin-bottom: 2rem;
}
.subheading {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.25rem;
}
.indicadores-section__note-text {
  color: #707070;
  font-size: 0.875rem;
  text-align: right;
  padding-right: 0.625rem;
}

@include media-breakpoint-up(lg) {
  .indicadores-section {
    padding: 6rem 0;
    border-top: 1px solid #EBEBEB;
  }
  .heading {
    font-size: 2.25rem;
    margin-bottom: 3rem;
  }
  .subheading { font-size: 1.75rem; }
}
</style>
